/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InsightFilter = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The InsightFilter model module.
   * @module model/InsightFilter
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>InsightFilter</code>.
   * @alias module:model/InsightFilter
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>InsightFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsightFilter} obj Optional instance to populate.
   * @return {module:model/InsightFilter} The populated <code>InsightFilter</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CategoryIDs')) {
        obj['CategoryIDs'] = ApiClient.convertToType(data['CategoryIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('BusinessModelCanvasItemIDs')) {
        obj['BusinessModelCanvasItemIDs'] = ApiClient.convertToType(data['BusinessModelCanvasItemIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('DashboardPageIDs')) {
        obj['DashboardPageIDs'] = ApiClient.convertToType(data['DashboardPageIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('DashboardPageBlockIDs')) {
        obj['DashboardPageBlockIDs'] = ApiClient.convertToType(data['DashboardPageBlockIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('MarketIDs')) {
        obj['MarketIDs'] = ApiClient.convertToType(data['MarketIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategyDescriptionIDs')) {
        obj['StrategyDescriptionIDs'] = ApiClient.convertToType(data['StrategyDescriptionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicGoalIDs')) {
        obj['StrategicGoalIDs'] = ApiClient.convertToType(data['StrategicGoalIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneIDs')) {
        obj['StrategicGoalMilestoneIDs'] = ApiClient.convertToType(data['StrategicGoalMilestoneIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicProgramIDs')) {
        obj['StrategicProgramIDs'] = ApiClient.convertToType(data['StrategicProgramIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ResponsibleUserIDs')) {
        obj['ResponsibleUserIDs'] = ApiClient.convertToType(data['ResponsibleUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('WorkshopWidgetIDs')) {
        obj['WorkshopWidgetIDs'] = ApiClient.convertToType(data['WorkshopWidgetIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('WorkspaceMindmapIDs')) {
        obj['WorkspaceMindmapIDs'] = ApiClient.convertToType(data['WorkspaceMindmapIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TaggedUserIDs')) {
        obj['TaggedUserIDs'] = ApiClient.convertToType(data['TaggedUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('InsightTypeIDs')) {
        obj['InsightTypeIDs'] = ApiClient.convertToType(data['InsightTypeIDs'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {Array.<Integer>} CategoryIDs
   */
  exports.prototype['CategoryIDs'] = undefined;
  /**
   * @member {Array.<Integer>} BusinessModelCanvasItemIDs
   */
  exports.prototype['BusinessModelCanvasItemIDs'] = undefined;
  /**
   * @member {Array.<Integer>} DashboardPageIDs
   */
  exports.prototype['DashboardPageIDs'] = undefined;
  /**
   * @member {Array.<Integer>} DashboardPageBlockIDs
   */
  exports.prototype['DashboardPageBlockIDs'] = undefined;
  /**
   * @member {Array.<Integer>} MarketIDs
   */
  exports.prototype['MarketIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategyDescriptionIDs
   */
  exports.prototype['StrategyDescriptionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicGoalIDs
   */
  exports.prototype['StrategicGoalIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicGoalMilestoneIDs
   */
  exports.prototype['StrategicGoalMilestoneIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicProgramIDs
   */
  exports.prototype['StrategicProgramIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ResponsibleUserIDs
   */
  exports.prototype['ResponsibleUserIDs'] = undefined;
  /**
   * @member {Array.<Integer>} WorkshopWidgetIDs
   */
  exports.prototype['WorkshopWidgetIDs'] = undefined;
  /**
   * @member {Array.<Integer>} WorkspaceMindmapIDs
   */
  exports.prototype['WorkspaceMindmapIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TaggedUserIDs
   */
  exports.prototype['TaggedUserIDs'] = undefined;
  /**
   * @member {Array.<Integer>} InsightTypeIDs
   */
  exports.prototype['InsightTypeIDs'] = undefined;



  return exports;
}));


